/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Productid2Inputs */

const en__field_productid2 = /** @type {(inputs: _Field_Productid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product reference (intern`)
};

const de__field_productid2 = /** @type {(inputs: _Field_Productid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkt Referenz (intern)`)
};

/**
* | output |
* | --- |
* | "Product reference (intern" |
*
* @param {_Field_Productid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_productid2 = /** @type {((inputs?: _Field_Productid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Productid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_productid2(inputs)
	return de__field_productid2(inputs)
});
export { _field_productid2 as "_field_productID" }